import { Box, BoxProps } from '@mui/material';
import React from 'react';

interface ColumnProps extends BoxProps {
    children: React.ReactNode;
}

const Column: React.FC<ColumnProps> = ({ children, sx = {}, ...props }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', ...sx }} {...props}>
            {children}
        </Box>
    )
};

export default Column;